import type { SVGProps } from 'react'

export const CreatorsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.33342 16.6667V13.25L8.91675 13.4167C9.3777 13.3911 9.81391 13.2 10.1452 12.8784C10.4765 12.5569 10.6806 12.1267 10.7201 11.6667V6.91669C10.7256 5.71614 10.254 4.56257 9.40898 3.70975C8.56398 2.85693 7.41479 2.37471 6.21425 2.36919C5.0137 2.36366 3.86013 2.83528 3.00731 3.68029C2.15449 4.52529 1.67227 5.67448 1.66675 6.87502C1.66675 9.20836 2.21341 9.42002 2.50008 10.6667C2.69382 11.4196 2.70211 12.2082 2.52425 12.965L1.66675 16.6667M16.5001 14.8333C17.6716 13.6617 18.33 12.0728 18.3305 10.4159C18.3309 8.75904 17.6735 7.16979 16.5026 5.99748M14.1668 12.4999C14.4395 12.2273 14.6554 11.9033 14.802 11.5468C14.9487 11.1902 15.0232 10.8081 15.0213 10.4226C15.0193 10.0371 14.941 9.65576 14.7907 9.30069C14.6405 8.94563 14.4214 8.62388 14.146 8.35404"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
